"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgCheckCircle = (props) => (React.createElement("span", { className: "anticon" },
    React.createElement("svg", Object.assign({ fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", className: "PayPing-icon" }, props),
        React.createElement("path", { d: "m23 11.011v1.0096a10.978 10.974 0 1 1-6.5101-10.03" }),
        React.createElement("polyline", { transform: "matrix(1.0978 0 0 1.0974 -1.1523 -1.1472)", points: "22 4 12 14.01 9 11.01" }))));
exports.default = SvgCheckCircle;
//# sourceMappingURL=CheckCircle.js.map